import { Maybe } from 'maybeasy';

export interface RationaleItem {
  quote: string;
  source: string;
}

export interface DashboardSummaryMetadata {
  dashboardId: string;
  tabId: Maybe<string>;
  generatedAt: string;
}

export interface DashboardSummaryFilters {
  startDate: Maybe<string>;
  endDate: Maybe<string>;
}

export interface DashboardSummaryPayload {
  summary: string;
  headline: Maybe<string>;
  rationale: Maybe<RationaleItem[]>;
  fullAnalysis: Maybe<string>;
  metadata: DashboardSummaryMetadata;
  filters: DashboardSummaryFilters;
}

export interface Idle {
  kind: 'idle';
}

export interface Loading {
  kind: 'loading';
  dashboardId: string;
  tabId: Maybe<string>;
}

export interface Success {
  kind: 'success';
  summary: DashboardSummaryPayload;
}

export interface Failed {
  kind: 'failed';
  error: string;
  dashboardId: string;
  tabId: Maybe<string>;
}

export interface Empty {
  kind: 'empty';
  message: string;
  filters: DashboardSummaryFilters;
  hadPreviousSuccess: boolean;
}

export type State = Idle | Loading | Success | Failed | Empty;

export const idle = (): Idle => ({
  kind: 'idle',
});

export const loading = (dashboardId: string, tabId: Maybe<string>): Loading => ({
  kind: 'loading',
  dashboardId,
  tabId,
});

export const success = (summary: DashboardSummaryPayload): Success => ({
  kind: 'success',
  summary,
});

export const failed = (error: string, dashboardId: string, tabId: Maybe<string>): Failed => ({
  kind: 'failed',
  error,
  dashboardId,
  tabId,
});

export const empty = (
  message: string,
  filters: DashboardSummaryFilters,
  hadPreviousSuccess: boolean,
): Empty => ({
  kind: 'empty',
  message,
  filters,
  hadPreviousSuccess,
});
